define('presentation/settings/outboundCallingCampaigns/validators/addOutboundCallingCampaignViewModelValidator',[
    'presentation/common/validation/commonValidator',
    'presentation/common/validation/validationRule'
], function () {
    return function () {
        const self = this;

        const CommonValidatorConstructor = require('presentation/common/validation/commonValidator');
        const ValidationRulesConstructor = require('presentation/common/validation/validationRule');

        let _addOutboundCallingCampaignViewModel;
        let _addOutboundCallingCampaignFacade;
        let _commonValidator = null;

        self.registerViewModel = (addOutboundCallingCampaignViewModel, addOOutboundCallingCampaignFacade) => {
            _commonValidator = new CommonValidatorConstructor(addOutboundCallingCampaignViewModel);

            const validationRules = new ValidationRulesConstructor();

            validationRules.field("name")
                .addValidationI18n(_commonValidator.isStringWithValue, 'addOutboundCallingCampaign:nameRequired');
            validationRules.field("outboundCallerId")
                .addValidationI18n(_commonValidator.isStringWithValue, 'addOutboundCallingCampaign:outboundCallerIdRequired');

            _addOutboundCallingCampaignViewModel = addOutboundCallingCampaignViewModel;
            _addOutboundCallingCampaignFacade = addOOutboundCallingCampaignFacade;

            _commonValidator.useManualValidation();
            _commonValidator.setValidationRules(validationRules);
        };

        self.validate = () => {
            return _commonValidator.validate();
        };
    };
});

